
import { useState } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const LivePage = () => {
  const [isLive] = useState(true);
  const [viewerCount] = useState(1247);
  const [messages, setMessages] = useState([
    { id: 1, user: 'Carlos_M', message: '¡Excelente contenido! 🔥', time: '10:23' },
    { id: 2, user: 'Ana_Lopez', message: 'Me encanta esta serie', time: '10:24' },
    { id: 3, user: 'Pedro_R', message: '¿Cuándo es el próximo stream?', time: '10:25' },
    { id: 4, user: 'Maria_G', message: 'Saludos desde México 🇲🇽', time: '10:26' },
    { id: 5, user: 'Luis_S', message: 'Increíble calidad de imagen', time: '10:27' }
  ]);
  const [newMessage, setNewMessage] = useState('');

  const handleSendMessage = (e: React.FormEvent) => {
    e.preventDefault();
    if (newMessage.trim()) {
      const message = {
        id: messages.length + 1,
        user: 'Tú',
        message: newMessage,
        time: new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })
      };
      setMessages([...messages, message]);
      setNewMessage('');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-12 px-6">
        <div className="max-w-7xl mx-auto text-center space-y-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="inline-flex items-center space-x-3 px-6 py-3 bg-red-500 rounded-full"
          >
            <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
            <span className="text-white font-bold text-lg uppercase tracking-wider">Transmisión en Vivo</span>
          </motion.div>
          
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-6xl lg:text-7xl font-black text-white"
          >
            Disfruta Nuestro <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-pink-500">Stream</span>
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-xl text-gray-300 max-w-3xl mx-auto"
          >
            Únete a nuestra comunidad y disfruta de contenido exclusivo en tiempo real
          </motion.p>
        </div>
      </section>

      {/* Live Stream Section */}
      <section className="px-6 pb-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Video Player */}
            <div className="lg:col-span-2">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="relative rounded-2xl overflow-hidden bg-black shadow-2xl"
              >
                {isLive ? (
                  <>
                    <div className="absolute top-6 left-6 z-10 flex items-center space-x-3">
                      <div className="flex items-center space-x-2 px-4 py-2 bg-red-500 rounded-full shadow-lg">
                        <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                        <span className="text-white text-sm font-bold uppercase">EN VIVO</span>
                      </div>
                      <div className="flex items-center space-x-2 px-4 py-2 bg-black/60 backdrop-blur-md rounded-full">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-eye-fill text-white"></i>
                        </div>
                        <span className="text-white text-sm font-bold">{viewerCount.toLocaleString()}</span>
                      </div>
                    </div>

                    <div className="w-full aspect-video">
                      <img
                        src="https://public.readdy.ai/ai/img_res/735f03e015bcb6137503edbf88fbb5d2.jpg"
                        alt="Live Stream"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>

                    {/* Video Controls */}
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/80 to-transparent p-6">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-4">
                          <button className="w-12 h-12 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md text-white hover:bg-white/30 transition-all duration-300 cursor-pointer">
                            <i className="ri-play-fill text-2xl"></i>
                          </button>
                          <button className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md text-white hover:bg-white/30 transition-all duration-300 cursor-pointer">
                            <i className="ri-volume-up-fill text-lg"></i>
                          </button>
                        </div>
                        <div className="flex items-center space-x-4">
                          <button className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md text-white hover:bg-white/30 transition-all duration-300 cursor-pointer">
                            <i className="ri-settings-3-fill text-lg"></i>
                          </button>
                          <button className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md text-white hover:bg-white/30 transition-all duration-300 cursor-pointer">
                            <i className="ri-fullscreen-fill text-lg"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="w-full aspect-video flex items-center justify-center bg-gradient-to-br from-gray-900 to-black">
                    <div className="text-center space-y-4">
                      <div className="w-20 h-20 flex items-center justify-center mx-auto rounded-full bg-white/10">
                        <i className="ri-live-line text-4xl text-gray-400"></i>
                      </div>
                      <h3 className="text-white text-2xl font-bold">Stream Offline</h3>
                      <p className="text-gray-400">La transmisión comenzará pronto</p>
                    </div>
                  </div>
                )}
              </motion.div>

              {/* Stream Info */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="mt-6 p-6 bg-gradient-to-br from-gray-900 to-black rounded-2xl border border-white/10"
              >
                <h2 className="text-white text-2xl font-bold mb-3">TV Plus+ Premium Live</h2>
                <p className="text-gray-300 mb-4">
                  Únete a nosotros para una noche especial de cine clásico. Comentaremos las mejores películas de todos los tiempos y compartiremos curiosidades fascinantes.
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-4 py-2 bg-pink-500/20 text-pink-400 rounded-full text-sm font-medium">Películas</span>
                  <span className="px-4 py-2 bg-purple-500/20 text-purple-400 rounded-full text-sm font-medium">Clásicos</span>
                  <span className="px-4 py-2 bg-cyan-500/20 text-cyan-400 rounded-full text-sm font-medium">Comentarios</span>
                </div>
              </motion.div>
            </div>

            {/* Chat Section */}
            <div className="lg:col-span-1">
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="bg-gradient-to-br from-gray-900 to-black rounded-2xl border border-white/10 overflow-hidden h-full flex flex-col"
              >
                <div className="p-6 border-b border-white/10">
                  <h3 className="text-white text-xl font-bold flex items-center space-x-2">
                    <i className="ri-chat-3-fill text-pink-500"></i>
                    <span>Chat en Vivo</span>
                  </h3>
                </div>

                <div className="flex-1 p-6 space-y-4 overflow-y-auto max-h-96">
                  {messages.map((msg) => (
                    <div key={msg.id} className="space-y-1">
                      <div className="flex items-center space-x-2">
                        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-gradient-to-br from-pink-500 to-purple-500 text-white text-xs font-bold">
                          {msg.user.charAt(0)}
                        </div>
                        <span className="text-pink-400 font-semibold text-sm">{msg.user}</span>
                        <span className="text-gray-500 text-xs">{msg.time}</span>
                      </div>
                      <p className="text-gray-300 text-sm ml-10">{msg.message}</p>
                    </div>
                  ))}
                </div>

                <form onSubmit={handleSendMessage} className="p-6 border-t border-white/10">
                  <div className="flex items-center space-x-2">
                    <input
                      type="text"
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                      placeholder="Escribe un mensaje..."
                      className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-full text-white placeholder-gray-400 text-sm outline-none focus:border-pink-500 transition-colors"
                    />
                    <button
                      type="submit"
                      className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white hover:shadow-lg hover:shadow-pink-500/50 transition-all duration-300 cursor-pointer"
                      aria-label="Send"
                    >
                      <i className="ri-send-plane-fill text-lg"></i>
                    </button>
                  </div>
                </form>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Social Links */}
      <section className="px-6 pb-24">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 p-1 rounded-3xl"
          >
            <div className="bg-black rounded-3xl p-12 text-center space-y-6">
              <h2 className="text-4xl font-black text-white">Síguenos en Nuestras Plataformas</h2>
              <p className="text-gray-300 text-lg max-w-2xl mx-auto">
                No te pierdas ninguna transmisión. Únete a nuestra comunidad en Telegram y Twitch
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a
                  href="https://t.me/TV_Plus17"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 px-8 py-4 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded-full font-bold hover:shadow-2xl hover:shadow-cyan-500/50 transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-telegram-fill text-2xl"></i>
                  <span>Telegram</span>
                </a>
                <a
                  href="https://twitch.tv/tv_plus17"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full font-bold hover:shadow-2xl hover:shadow-purple-500/50 transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-twitch-fill text-2xl"></i>
                  <span>Twitch</span>
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LivePage;
